"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "terzo-d-aquileia": {
    "318045a8": [{
      "hkey": "5ab9437d",
      "slug": "terzo-d-aquileia",
      "name": "Terzo d'Aquileia",
      "primary": true,
      "skipSearch": false
    }],
    "muruzzis": [{
      "hkey": "5ab9437d",
      "slug": "terzo-d-aquileia",
      "name": "Terzo d'Aquileia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "daf0a63f": [{
      "hkey": "5ab9437d",
      "slug": "terzo-d-aquileia",
      "name": "Terzo d'Aquileia",
      "primary": true,
      "skipSearch": false
    }],
    "paludo": [{
      "hkey": "5ab9437d",
      "slug": "terzo-d-aquileia",
      "name": "Terzo d'Aquileia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "75c7e7d8": [{
      "hkey": "94052180",
      "slug": "ponterosso",
      "name": "Ponterosso",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-rosso": [{
      "hkey": "94052180",
      "slug": "ponterosso",
      "name": "Ponterosso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c7b43f27": [{
      "hkey": "8a8dc764",
      "slug": "terzo-san-martino",
      "name": "Terzo-San Martino",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "8a8dc764",
      "slug": "terzo-san-martino",
      "name": "Terzo-San Martino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "terzo-d-aquileia"
    }],
    "8d58a1ad": [{
      "hkey": "8a8dc764",
      "slug": "terzo-san-martino",
      "name": "Terzo-San Martino",
      "primary": true,
      "skipSearch": false
    }],
    "terzo": [{
      "hkey": "8a8dc764",
      "slug": "terzo-san-martino",
      "name": "Terzo-San Martino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;